const ListRefundType = () => import('./ListRefundType.vue')
const NewRefundType = () => import('./NewRefundType.vue')
const EditRefundType = () => import('./EditRefundType.vue')
const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/admin/refund-types',
        name: 'refundType',
        component: TheContainer,
        meta: {
            perms: ['admin.refund_type.list'],
            breadcrumb: {
                text: 'Refund Types',
                to: { name: 'refundType.list' }
            }
        },
        children: [
            {
                path: '',
                name: 'refundType.list',
                component: ListRefundType,
            },
            {
                path: 'new',
                name: 'refundType.new',
                component: NewRefundType,
                meta: {label: 'Create New'},
            },
            {
                path: ':id',
                name: 'refundType.edit',
                component: EditRefundType,
                meta: {label: 'Edit'},
            },
        ]
    }
]
